import { Component, OnInit, Input, ViewChild, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormControl, Validators, AbstractControl, NgForm } from '@angular/forms';
import { PropertyListingService } from '../shared/providers/property-listing.service';
import { IPropertySearchCriteria } from '../shared/models/propertysearchcriteria';
import { IPropertyCard, PropertyIdList } from '../shared/models/propertycard';
import { DataTablesResponse } from '../shared/models/datatables-response';
import { PropertyListingBase } from '../property-listing/property-listing-base';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { IFilterable } from '../property-listing/filterable';
import { Router } from '@angular/router';
import { AuthenticationService } from '../shared/auth/authentication.service';
import { LoaderService } from '../shared/providers/loader.service';
import { OpportunityOfferOutputModel } from '../shared/models/OpportunityOfferOutputModel';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastService } from '../shared/providers/toast.service';
import { ValidationService } from '../shared/providers/validation.service';
import { INoteInput } from '../shared/models/NotesInputModel';
import { BreadCrumbInput } from '../shared/models/BreadCrumbInputModel';
import { ActivatedRoute, Params } from '@angular/router';
import { ILookUp } from '../shared/models/LookUpOutputModel';
import { CommonService } from '../shared/providers/common.service';
import { IStatesList } from '../shared/models/StatesListOutputModel';
import { PropertyManagementService } from '../shared/providers/property-management.service';
import { BrokerageManagerService } from '../shared/providers/brokerage-manager.service';
import { SavePropertyBrokerInputModel, BrokerSelecttionModel } from '../shared/models/SavePropertyInputModel';
import { collapseColumns } from '../shared/models/collapseColumns';
import { Subject } from 'rxjs';
import { OfferService } from '../shared/providers/offer.service';

enum Actions {
  NothingSelected = 0,
  ChangeStatus = 1,
  MarkAsComp = 2,
  MarkAsArchive = 3,
  AssignBroker = 4,
  Delete = 5,
  MergeRecords = 6
}

enum CompOrArhive {
  Comp = 1,
  Archive = 2
}
export enum PropertyType {
  Sale = 601,
  Exchange1031 = 602
}

interface AssignBrokerInputModel {
  stateId: number;
  brokerId: number;
  licenseId: number;
  propertyId: number[];
}

interface IProperty extends IPropertyCard {
  DateOnMarket?: Date;
  CharacteristicsId: number;
}


@Component({
  selector: 'my-property-view',
  templateUrl: './my-property-listing.component.html',
  styleUrls: ['my-property-listing.component.css'],
})
export class MyPropertyListViewComponent extends PropertyListingBase implements IFilterable {
  currentPoint: number;
  propertiesEx: IProperty[];
  selectedRows: IProperty[] = [];
  BuyerQuestionsOfferId: number = 0;
  BuyerQuestionsPropertyId: number = 0;
  modalBuyerRef: BsModalRef;
  _takeCount = 5;
  @Input() searchCriteria: IPropertySearchCriteria;
  searchCriteriaForExport = {} as IPropertySearchCriteria;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  user: any;
  dtOptions = {};
  IsLoading = false;
  dtOptionExport = {};
  role: string;
  offers: OpportunityOfferOutputModel[];
  //propertyCount: number;
  quickEditDetails = [];
  public offerPageUrl: string = '';
  prevRoute = null;
  link = null;
  fromPage: string = this.router.url;
  NotesInput = {} as INoteInput;
  @Input() PrincipalId: number = 0;
  @Input() exchangeSelected: number = null;
  @Input() exchangeGuid: string = null;
  @Input() breadCrumbInput: BreadCrumbInput = null;
  @Input() activeTab: string = null;
  selectedPropertyId: string;
  isDataEntryProperty: boolean = false;
  BreadCrumb = {} as BreadCrumbInput;
  propertyType = PropertyType;
  currentTab = PropertyType.Sale;
  prevTab = PropertyType.Sale
  selectedAction = 0;
  statusToChange = 0;
  propertyStatusList: ILookUp[];
  assignBrokerInputModel = {} as AssignBrokerInputModel;
  selectedSubTab = 1;
  propertyIdList: PropertyIdList[];
  selectedColumns = [];
  capratetext: string;
  selectedOfferId: number;
  //defaultTypeText: IMultiSelectTexts = {
  //  //checked: 'column selected',
  //  //checkedPlural: 'columns selected',
  //  defaultTitle: 'Select Columns',
  //};
  defaultTypeSettings = {
    singleSelection: false,
    text: "Select Columns",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
  }
  dtTrigger = new Subject();
  IsPortfolio = false as boolean;
  sharedOmProperties: number[] = [];
  constructor(private router: Router, protected http: HttpClient, protected _propertyListingService: PropertyListingService, private offerService: OfferService, public authService: AuthenticationService, protected loaderService: LoaderService, private modalService: BsModalService, private _toastService: ToastService, protected activatedRoute: ActivatedRoute, public Validation: ValidationService, private _commonService: CommonService, private _propertyManagementService: PropertyManagementService, private _brokerageManagerService: BrokerageManagerService, private cdRef: ChangeDetectorRef
    , private _loader: LoaderService, private _propertyManagerService: PropertyManagementService) {
    super(_propertyListingService, http, authService, loaderService, activatedRoute);
    this.Validation.IfNoAccessThenRedirect('LiveListings', 'View');
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params["TenantId"]) {
        this.resetSelectedRows();
      }

      if (params["prevRoute"]) {
        this.prevRoute = params["prevRoute"];
      }

      if (params["link"]) {
        this.link = params["link"];
      }

    });

  }

  onBreadCrumbClick() {

    this.router.navigateByUrl(this.link);
  }

  redirect(PropertyGuid, OfferDetailGuid) {
    if (this.callFromComponent) {
      this.router.navigateByUrl('place-offer/' + PropertyGuid + "/" + OfferDetailGuid + "/dashboard-1031@@" + this.exchangeGuid + "?tab=offers");
    }
    else {
      this.router.navigateByUrl('place-offer/' + PropertyGuid + "/" + OfferDetailGuid + "/placed-offers");
    }
  }
  filter(searchParameters: IPropertySearchCriteria) {
    this.searchCriteria = searchParameters;
    //this.BindColumns();

    this.dtElement.dtInstance.then(x => x.draw(false));
    //this.dtElement.dtInstance.then((dtInstance) => {
    //  dtInstance.destroy();
    //  this.dtTrigger.next(true);
    //});
  }
  viewDetail(guid: any) {
    this.router.navigate(['/viewproperty/' + guid]);
  }

  isArchive: boolean = false;
  ArchiveTab(val) {
    this.selectedSubTab = val;
    this.isArchive = val == 1 ? false : true;
    this.dtElement.dtInstance.then(x => x.draw());
  }

  closeModal($event) {
    this.modalRef.hide();
    this.dtElement.dtInstance.then(x => x.draw());
  }
  exportToExcel() {
    this.loaderService.display(true);
    this.searchCriteriaForExport = this.searchCriteria;
    this.searchCriteriaForExport.IsExport = true;
    var loggedinUserId = this.user.Id;
    const inputModel =
    {
      Extra_param: this.searchCriteria
    }

    let dataTablesParameters = inputModel;

    dataTablesParameters.Extra_param = this.searchCriteriaForExport;
    dataTablesParameters.Extra_param.IsComp = false;
    dataTablesParameters.Extra_param.IsArchive = false;
    dataTablesParameters.Extra_param.PropertyFor = this.currentTab;
    var newDate = new Date();
    var offset = newDate.getTimezoneOffset() / 60;
    dataTablesParameters.Extra_param.CurrentOffset = offset;
    const httpHeader = this.Validation.GetAuthHeader();
    this.http.post<string>(this.BASE_URL + '/property/mypropertieslistview/' + loggedinUserId, dataTablesParameters, httpHeader).subscribe(resp => {
      let filenameWithExtension: string = resp.toString();
      let filenameWithoutExtension = filenameWithExtension.toString().split('.')[0];
      this.Validation.downloadExcelFile('/upload/excelfile/' + filenameWithoutExtension, 'Property List.xlsx');
      this.loaderService.display(false);
    });
  }
  propertySearchCriteria(searchParameters: IPropertySearchCriteria) {
    //this.resetSelectedRows();
    this.currentPoint = 0;
    this.searchCriteria = searchParameters;
    const searchCriteria: IPropertySearchCriteria = {
      Address: this.searchCriteria.Address,
      AssetTypes: this.searchCriteria.AssetTypes,
      Ratings: this.searchCriteria.Ratings,
      PriceFrom: this.searchCriteria.PriceFrom,
      PriceTo: this.searchCriteria.PriceTo,
      SkipCount: this.currentPoint,
      SortValue: this.searchCriteria.SortValue,
      TakeCount: this._takeCount,
      Tenants: this.searchCriteria.Tenants,
      Terms: this.searchCriteria.Terms,
      IsMapView: false,
      Guid: this.searchCriteria.Guid,
      NOIFrom: this.searchCriteria.NOIFrom,
      NOITo: this.searchCriteria.NOITo,
      BuildingSizeFrom: this.searchCriteria.BuildingSizeFrom,
      BuildingSizeTo: this.searchCriteria.BuildingSizeTo,
      YearBuiltFrom: this.searchCriteria.YearBuiltFrom,
      YearBuiltTo: this.searchCriteria.YearBuiltTo,
      StateId: this.searchCriteria.StateId ? this.searchCriteria.StateId[0] : null,
      LeaseStructures: this.searchCriteria.LeaseStructures,
      CapRateFrom: this.searchCriteria.CapRateFrom,
      CapRateTo: this.searchCriteria.CapRateTo,
      PropertyStatus: this.searchCriteria.PropertyStatus,
      SubCategories: this.searchCriteria.SubCategories,
      IsRentAmount: this.searchCriteria.IsRentAmount,
      RentFrom: this.searchCriteria.RentFrom,
      RentTo: this.searchCriteria.RentTo,
      OwnershipTypes: this.searchCriteria.OwnershipTypes,
      IsExcludeSoldListing: this.searchCriteria.IsExcludeSoldListing,
      IsOnlySoldListing: this.searchCriteria.IsOnlySoldListing,
      IsExcludeContractListing: this.searchCriteria.IsExcludeContractListing,
      IsOnlyFeaturedListing: this.searchCriteria.IsOnlyFeaturedListing,
      LoggedInUserId: this.searchCriteria.LoggedInUserId,
      IsFavorite: this.searchCriteria.IsFavorite,
      PropertyFor: this.searchCriteria.PropertyFor,
      IsComp: true,
      IsArchive: false,
      IsDisliked: this.searchCriteria.IsDisliked,
      IsSearchButtonClicked: this.searchCriteria.IsSearchButtonClicked,
      MinTerm: this.searchCriteria.MinTerm,
      MaxTerm: this.searchCriteria.MaxTerm,
      Brokerages: this.searchCriteria.Brokerages,
      States: this.searchCriteria.States,
      AddressTypeId: this.searchCriteria.AddressTypeId,
      AddressType: this.searchCriteria.AddressType,
      AddressTypeName: this.searchCriteria.AddressTypeName,
      CharacteristicsId: this.searchCriteria.CharacteristicsId,
      IsPortfolio: this.searchCriteria.IsPortfolio,
      PortfolioSaleOnly: this.searchCriteria.PortfolioSaleOnly,
      PropertySequenceId: this.searchCriteria.PropertySequenceId,
      DOMStartDate: this.searchCriteria.DOMStartDate == null ? null : this.Validation.utcify(this.searchCriteria.DOMStartDate),
      DOMEndDate: this.searchCriteria.DOMEndDate == null ? null : this.Validation.utcify(this.searchCriteria.DOMEndDate),
      TenantAddress: this.searchCriteria.TenantAddress,
      CityId: this.searchCriteria.CityId
    };
    //this.BindColumns();
    this.searchCriteria.IsExport = false;
    this.searchCriteria = searchCriteria;
    super.holdPropertySearchCriteria(searchCriteria);
    //
    //this.dtElement.dtInstance.then(x => x.draw());
    this.BindColumns();
    this.dtElement.dtInstance.then(x => x.draw());
    //this.dtElement.dtInstance.then((dtInstance) => {
    //  dtInstance.destroy();
    //  this.dtTrigger.next(true);
    //});
    //this.dtElement.dtInstance.then((dtInstance: ) => {
    //    // Destroy the table first
    //    dtInstance.destroy();
    //    // Call the dtTrigger to rerender again
    //    //this.dtTrigger.next();
    //});
  }

  returnUrl = null;
  onSearch(text: string) {
    this.dtElement.dtInstance.then(x => x.search(text).draw());
  }
  callFromComponent = false;
  setBreadCrumb() {
    if (this.authService.IsUserRole(this.authService.UserRole.Principal1031) || this.PrincipalId !== 0) {
      this.returnUrl = 'Deals';
      if (this.breadCrumbInput === null) {
        const BC =
        {
          PrevPageName: "Deals",
          PrevPageLink: "dashboard-1031"
        }
        this.BreadCrumb = BC;
      }
      else {
        this.BreadCrumb.PrevPageName = "Deals";
        this.BreadCrumb.PrevPageLink = this.breadCrumbInput.PrevPageLink;
        this.BreadCrumb.AdditionalLinkParams = this.breadCrumbInput.AdditionalLinkParams;
        if (this.activeTab !== null && this.activeTab !== undefined) {
          this.BreadCrumb.PrevPageLink += "?tab=" + this.activeTab;
        }
      }
    }
    else if (this.authService.IsUserRole(this.authService.UserRole.ExternalBroker) || this.PrincipalId !== 0) {
      this.BreadCrumb.PrevPageName = "My Deals";
      this.BreadCrumb.PrevPageLink = this.router.url;
    }
    else {
      const BC =
      {
        PrevPageName: null,
        PrevPageLink: null
      }
      this.BreadCrumb = BC;
    }
  }
  resetBrokerAssign() {
    this.assignBrokerInputModel.stateId = 0;
    this.assignBrokerInputModel.brokerId = 0;
    this.assignBrokerInputModel.licenseId = 0;
  }
  totalSourceChangedCount = 0;
  IsExternalBroker = false;
  is1031Property = false;
  hasBrokerageFilter = false;
  dataColums = [];
  tableColumns: collapseColumns[] = [];
  hasTenantFilter = false;
  ngOnInit() {
    this.searchCriteria = this._propertyListingService.criteria;
    if (this.searchCriteria.PropertyFor > 0) {
      this.currentTab = this.searchCriteria.PropertyFor;
    }
    this.offerPageUrl = this.router.url;
    this.activatedRoute.queryParams.subscribe((params: Params) => {

      if (params['brokerage']) {

        this.searchCriteria = {} as IPropertySearchCriteria;
        this.hasBrokerageFilter = true;
        this.searchCriteria.Brokerages = [];
        this.searchCriteria.Address = "";
        this.searchCriteria.AddressTypeId = 0;
        this.searchCriteria.AddressType = 0;
        this.searchCriteria.AddressTypeName = null;
        this.searchCriteria.Brokerages.push(parseInt(params['brokerage']));
        let propStatus: number[] = [351, 352, 354, 356];
        this.searchCriteria.PropertyStatus = propStatus;
        this.searchCriteria.PropertyFor = 602;
        this.currentTab = this.propertyType.Exchange1031;

        this.hasTenantFilter = false;
        this.searchCriteria.Address = "";
        this.searchCriteria.AddressTypeId = 0;
        this.searchCriteria.AddressType = 0;
        this.searchCriteria.AddressTypeName = null;
        this.propertySearchCriteria(this.searchCriteria);
      }
      else if (params["TenantId"]) {

        this.searchCriteria = {} as IPropertySearchCriteria;
        this.hasTenantFilter = true;
        let tenantsDetails = {
          Address: params['TenantName'],
          AddressTypeId: 0,
          AddressType: 1,
          AddressTypeName: "Tenant"
        }
        this.searchCriteria.TenantAddress.push(tenantsDetails);
        this.searchCriteria.PropertyFor = 602;
        this.currentTab = this.propertyType.Exchange1031;
        this.propertySearchCriteria(this.searchCriteria);
        this.resetSelectedRows();
      }
      //else {  // Commented to retain tenant autocompleate filter after applying filter 
      //    this.hasBrokerageFilter = false;
      //    this.searchCriteria.Brokerages = [];
      //    this.hasTenantFilter = false;
      //    this.searchCriteria.Address = "";
      //    this.searchCriteria.AddressTypeId = 0;
      //    this.searchCriteria.AddressType = 0;
      //    this.searchCriteria.AddressTypeName = null;
      //    this.searchCriteria.PropertyStatus = []
      //}
    });

    this.user = this.authService.user;
    var loggedinUserId = this.user.Id;
    const that = this;
    this.role = this.user.Role;
    if (this.PrincipalId > 0) {
      this.callFromComponent = true;
    }
    this.resetBrokerAssign();

    if (this.authService.IsUserRole(this.authService.UserRole.ExternalBroker)) {
      this.IsExternalBroker = true;
    }
    if ((this.authService.IsUserRole(this.authService.UserRole.Principal) || this.IsExternalBroker || this.authService.IsUserRole(this.authService.UserRole.Principal1031)) || this.PrincipalId !== 0) {
      this.setBreadCrumb();

      this.role = "Principal";
      let tblColums = [
        { data: 'OfferDate' },
        { data: 'OfferDate' },
        { data: 'NotAnsweredQustionsCount' },
        { data: 'LeadName' },
        { data: 'TenantName' },
        { data: 'StatusName' },
        { data: 'PrimaryContactName' },
        { data: 'Price' },
        { data: 'OfferPrice' },
        { data: 'EarnestMoneyDeposit' },
        { data: 'DueDiligencePeriod' },
        { data: 'ClosingPeriod' },
        { data: 'Comments' }];

      if ((this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.Principal1031) || this.authService.IsUserRole(this.authService.UserRole.Broker)) && (this.exchangeSelected == null || this.exchangeSelected == 0 || this.exchangeSelected == undefined)) {
        tblColums = [
          { data: 'OfferDate' },
          { data: 'OfferDate' },
          { data: 'NotAnsweredQustionsCount' },
          { data: 'LeadName' },
          { data: 'TenantName' },
          { data: 'StatusName' },
          { data: 'PrimaryContactName' },
          { data: 'Price' },
          { data: 'OfferPrice' },
          { data: 'EarnestMoneyDeposit' },
          { data: 'DueDiligencePeriod' },
          { data: 'ClosingPeriod' },
          { data: 'Comments' }];
      }
      if (this.IsExternalBroker) {
        if (this.exchangeSelected != null && this.exchangeSelected != undefined) {
          tblColums = [
            { data: 'OfferDate' },
            { data: 'OfferDate' },
            { data: 'NotAnsweredQustionsCount' },
            { data: 'LeadName' },
            { data: 'TenantName' },
            { data: 'StatusName' },
            { data: 'PrimaryContactName' },
            { data: 'Price' },
            { data: 'OfferPrice' },
            { data: 'EarnestMoneyDeposit' },
            { data: 'DueDiligencePeriod' },
            { data: 'ClosingPeriod' },
            { data: 'Comments' }];
        }
        else {
          tblColums = [
            { data: 'OfferDate' },
            { data: 'OfferDate' },
            { data: 'NotAnsweredQustionsCount' },
            { data: 'LeadName' },
            { data: 'TenantName' },
            { data: 'StatusName' },
            { data: 'PrimaryContactName' },
            { data: 'Price' },
            { data: 'OfferPrice' },
            { data: 'EarnestMoneyDeposit' },
            { data: 'DueDiligencePeriod' },
            { data: 'ClosingPeriod' },
            { data: 'Comments' }];
        }

      }

      this.dtOptions = {
        pagingType: 'full_numbers',
        serverSide: true,
        processing: true,
        info: false,
        language: {
          zeroRecords: null,
          processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
        },
        "pageLength": 50,
        "order": [[0, "desc"]],
        bLengthChange: false,
        initComplete: () => $('.dataTables_filter').css('display', 'none'),
        ajax: (dataTablesParameters: any, callback: Function) => {
          this.IsLoading = true;
          if (this.exchangeSelected !== null && this.exchangeSelected !== undefined) {
            const filter =
            {
              ExchangeId: this.exchangeSelected,
              IsArchive: this.isArchive
            }
            dataTablesParameters.Extra_param = filter
          }
          const httpHeader = this.GetAuthHeader();
          that.http
            .post<DataTablesResponse>(
              this.BASE_URL + '/opportunity/principalOffers/' + this.PrincipalId + '/' + loggedinUserId,
              dataTablesParameters, httpHeader
            ).subscribe(resp => {
              that.offers = resp.data ? resp.data : [];
              if (resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide()
              }
              if (resp) {
                callback({
                  recordsTotal: resp.recordsTotal,
                  recordsFiltered: resp.recordsFiltered,
                  data: []
                });
              } else {
                callback({
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  data: []
                });
              }
              $(".paginate_button.first,.paginate_button.last").hide();
              this.IsLoading = false;
            });
        },
        columnDefs: [
          { orderable: false, targets: 0 }
        ],
        columns: tblColums
      };
    }
    else {
      this.reassignSelectedRows();
      this.BindColumns();
      if (this.currentTab === PropertyType.Exchange1031) {
        this.is1031Property = true;
      }
      else {
        this.is1031Property = false;
      }
      let defaultOrder = 6;
      if (this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)) {
        this.dataColums = [
          { data: 'PropertyName' },
          { data: 'PropertyName' },
          { data: 'PropertyName' },
          { data: 'PropertySequenceId' },
          { data: 'PropertyName' },
          { data: 'IsSourceChanged' },
          { data: 'LastVerifiedDate' },
          { data: 'State' },
          { data: 'City' },
          //{ data: 'BrokerCount' },
          { data: 'BrokerageName' },
          { data: 'PropertyStatus' },
          { data: 'Price' },
          { data: 'RentNOI' },
          { data: 'CreditRating' },
          { data: 'CapRate' },
          { data: 'RemainingTerm' },
          { data: 'DateOnMarket' },
          { data: 'LeaseStructure' },
          { data: 'BuildingSize' },
          { data: 'SourceUrl' },
          { data: 'Rank' },
        ]
      }
      else if (this.authService.IsUserRole(this.authService.UserRole.Broker)) {
        defaultOrder = 3;
        this.dataColums = [
          { data: 'PropertyName' },
          { data: 'PropertyName' },
          { data: 'PropertySequenceId' },
          { data: 'PropertyName' },
          { data: 'LastVerifiedDate' },
          { data: 'State' },
          { data: 'City' },
          //{ data: 'BrokerCount' },
          { data: 'BrokerageName' },
          { data: 'PropertyStatus' },
          { data: 'Price' },
          { data: 'RentNOI' },
          { data: 'CreditRating' },
          { data: 'CapRate' },
          { data: 'RemainingTerm' },
          { data: 'DateOnMarket' },
          { data: 'LeaseStructure' },
          { data: 'BuildingSize' },
          { data: 'SourceUrl' },
          { data: 'Rank' },
        ]
      }

      //this.role = "Admin";
      this.dtOptions = {
        pagingType: 'full_numbers',
        serverSide: true,
        processing: true,
        info: false,
        language: {
          zeroRecords: null,
          processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
        },
        "pageLength": 50,
        "order": [[defaultOrder, "desc"]],
        stateSave: true,
        stateSaveCallback: function (settings, data) {
          localStorage.setItem("DataTables_my_property_list_view", JSON.stringify(data));
        },
        stateLoadCallback: function (settings) {
          let localStorageName = "DataTables_my_property_list_view";
          let data = JSON.parse(localStorage.getItem(localStorageName));
          if (data != null) {
            if (that.searchCriteria.AddressType == 1) {
              var tableStates = JSON.parse(localStorage.getItem('TableStates'));
              if (tableStates != null) {
                tableStates.forEach(item => {
                  if (item.TableName == localStorageName && item.IsSortOrderChanged) {
                    item.IsSortOrderChanged = false;
                    //data.order = [[that.dataColums.findIndex(x => x.data == "Rank"), "desc"]];
                    data.order = [[defaultOrder, "desc"]];
                  }
                });
                localStorage.setItem('TableStates', JSON.stringify(tableStates));
              }
            }
            else if (data.order[0][0] == that.dataColums.findIndex(x => x.data == "Rank")) {
              data.order = [[defaultOrder, "desc"]];
            }
          }
          $(".dataTables_paginate.paging_full_numbers").show();
          return data;
        },
        bLengthChange: false,
        initComplete: () => $('.dataTables_filter').css('display', 'none'),
        ajax: (dataTablesParameters: any, callback: Function) => {
          this.IsLoading = true;
          // this.searchCriteria.PropertyFor = this.currentTab;                    
          this.searchCriteria.IsExport = false;
          dataTablesParameters.Extra_param = this.searchCriteria;
          dataTablesParameters.Extra_param.IsComp = false;
          dataTablesParameters.Extra_param.IsArchive = false;
          dataTablesParameters.Extra_param.PropertyFor = this.currentTab;

          if (!this.hasBrokerageFilter) {
            dataTablesParameters.Extra_param.Brokerages = this._propertyListingService.selectedBrokerage;
          }
          if (this.currentTab === PropertyType.Exchange1031) {
            this.is1031Property = true;
          }
          else {
            this.is1031Property = false;
          }
          const httpHeader = this.GetAuthHeader();
          that.http
            .post<DataTablesResponse>(
              this.BASE_URL + '/property/mypropertieslistview/' + loggedinUserId,
              dataTablesParameters, httpHeader
            ).subscribe(resp => {
              if (this.prevTab != this.currentTab) {
                this.BindColumns();
              }
              this.prevTab = this.currentTab;

              that.propertiesEx = resp.data ? resp.data : [];
              let checkedCount = 0;
              that.propertiesEx.forEach(item => {
                if (item.SourceUrl) {
                  item.SourceUrl = this.Validation.formatURL(item.SourceUrl);
                }
                if (this.selectedRows.findIndex(x => x.Id == item.Id) > -1) {
                  item.IsSelected = true;
                  checkedCount++;
                }
                item.Remaining_Term = !item.IsPortfolio ?
                  this.Validation.remainingTermForCardandTables(item.LeaseExpiration, item.LeaseCommencementDate) : '';

                if (item.CharacteristicsId == 1) {
                  item.capRateText = 'ZCF';
                }
                else {
                  item.capRateText = item.CapRate;
                }
              });
              if (that.propertiesEx.length > 0) {
                this.totalSourceChangedCount = that.propertiesEx[0].TotalSourceChanged;
              }
              this.selectAll = false;
              this.autoSelectAll();

              if (that.propertiesEx.length > 0) {
                this.propertyCount = this.propertiesEx[0].TotalCount;
              }
              else {
                this.propertyCount = 0;
              }
              if (resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide()
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show()
              }
              if (resp) {
                callback({
                  recordsTotal: resp.recordsTotal,
                  recordsFiltered: resp.recordsFiltered,
                  data: []
                });
              } else {
                callback({
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  data: []
                });
              }
              that.showAllPortfolioProperties(that.propertiesEx.filter(x => x.IsPortfolio).map(x => x.Id))

              $(".paginate_button.first,.paginate_button.last").hide();
              this.IsLoading = false;
            });
        },
        columnDefs: [
          { orderable: false, targets: 0 },
          { orderable: false, targets: 1 }
        ],
        columns: this.dataColums
      };
      this.LoadPropertyStatus();
    }
  }

  ngAfterViewInit(): void {
    this.cdRef.detectChanges();
    this.dtTrigger.next(true);
  }

  hideColumn(col: number) {
    if (this.selectedColumns.indexOf(col) > -1) {
      return false; // show
    }
    else {
      return true; // hide
    }
  }
  BindColumns() {
    if (this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)) {
      this.tableColumns = [
        { id: 1, name: 'Source Change' },
        { id: 2, name: 'Last Updated' },
        { id: 3, name: 'State' },
        { id: 4, name: 'City' },
        //{ id: 5, name: 'Brokerage' },
        { id: 6, name: 'Status' },
        { id: 7, name: 'Asking Price' },
        { id: 8, name: 'Rent NOI' },
        { id: 9, name: 'Credit Rating' },
        { id: 10, name: 'Cap Rate' },
        { id: 11, name: 'Remaining Term' },
        { id: 12, name: 'Lease Structure' },
        { id: 13, name: 'Area (SQ FT)' },
        { id: 14, name: 'Souce URL' },
        { id: 16, name: 'Date On Market' },
      ]
      //if (this.currentTab == PropertyType.Sale) {
      //    this.tableColumns.splice(4, 1);
      //}
    }
    else if (this.authService.IsUserRole(this.authService.UserRole.Broker)) {
      this.tableColumns = [
        { id: 2, name: 'Last Updated' },
        { id: 3, name: 'State' },
        { id: 4, name: 'City' },
        //{ id: 5, name: 'Brokerage' },
        { id: 6, name: 'Status' },
        { id: 7, name: 'Asking Price' },
        { id: 8, name: 'Rent NOI' },
        { id: 9, name: 'Credit Rating' },
        { id: 10, name: 'Cap Rate' },
        { id: 11, name: 'Remaining Term' },
        { id: 12, name: 'Lease Structure' },
        { id: 13, name: 'Area (SQ FT)' },
        { id: 16, name: 'Date On Market' },
      ]
      //if (this.currentTab == PropertyType.Sale) {
      //    this.tableColumns.splice(3, 1);
      //}
    }

    //if (this.searchCriteria.AddressType == 1) {
    //    this.tableColumns.push({ id: 15, name: 'Rank' });
    //}

    this.selectedColumns = [];
    /* this.cdRef.detectChanges();*/

    if (this.currentTab == PropertyType.Sale) {
      if (localStorage.getItem("live_listings_sale_selectedColumns_LS") !== null) {
        this.selectedColumns = JSON.parse(localStorage.getItem("live_listings_sale_selectedColumns_LS"));
      }
      else {
        this.tableColumns.forEach(item => {
          this.selectedColumns.push(item.id);
        });

        if (this.selectedColumns.indexOf(5) < 0) {
          this.selectedColumns.push(5);
        }
      }
    }
    else {
      if (localStorage.getItem("live_listings_1031_selectedColumns_LS") !== null) {
        this.selectedColumns = JSON.parse(localStorage.getItem("live_listings_1031_selectedColumns_LS"));
      }
      else {
        this.tableColumns.forEach(item => {
          this.selectedColumns.push(item.id);
        });

        if (this.selectedColumns.indexOf(5) < 0) {
          this.selectedColumns.push(5);
        }
      }
    }

    //if (this.searchCriteria.AddressType != 1 && this.selectedColumns.indexOf(15) > -1) {       
    //    this.selectedColumns.splice(this.selectedColumns.indexOf(15), 1);
    //}
    //else if (this.searchCriteria.AddressType == 1 && this.selectedColumns.indexOf(15) == -1) {         
    //    this.selectedColumns.push(15);
    //}
    //this.cdRef.detectChanges();

  }

  modalRef: BsModalRef;
  modalRefShareListing: BsModalRef;
  modalRefOM: BsModalRef;
  propertyToDelete: string;
  property: string;
  deleteIndex: number;
  openModal(template: TemplateRef<any>, classes: any, propertyToDelete: string, propertyName: string, index: number) {
    this.propertyToDelete = propertyToDelete;
    this.property = propertyName;
    this.deleteIndex = index;
    this.IsPortfolio = this.propertiesEx[index].IsPortfolio;
    this.modalRef = this.modalService.show(template, { class: classes });
  }
  isSubmit = false;

  openModalForNotes(template: TemplateRef<any>, classes, objectId, offer) {
    offer.UnReadNoteCount = 0;
    this.isSubmit = false;

    this.NotesInput.Id = 0;
    this.NotesInput.Description = '';
    this.NotesInput.UserId = this.user.Id;


    this.NotesInput.ObjectId = objectId;
    this.NotesInput.ObjectTypeId = 303;
    this.modalRef = this.modalService.show(template, { class: classes });
  }
  openModalForQuickEdit(template: TemplateRef<any>, classes: any, id, state, city, name) {
    this.quickEditDetails = [];
    this.modalRef = this.modalService.show(template, { class: classes });
    this.selectedPropertyId = id;
    this.quickEditDetails.push(state, city, name);
  }


  openModalDeleteOffer(OfferDelete: TemplateRef<any>, classes: any, id: number, index: number) {
    this.selectedOfferId = id;
    this.modalRef = this.modalService.show(OfferDelete, { class: classes });
  }

  deleteProperty() {
    let text = this.IsPortfolio ? "Portfolio" : "Property";
    var loggedinUserId = this.user.Id;
    this._propertyListingService.deleteProperty(this.propertyToDelete, loggedinUserId).subscribe(response => {
      if (response) {
        this.propertiesEx.splice(this.deleteIndex, 1);
        let propertyIndexToDelete = this.selectedRows.findIndex(x => x.Guid == this.propertyToDelete);
        if (propertyIndexToDelete > -1) {
          this.selectedRows.splice(propertyIndexToDelete, 1);
          this.preserveSelectedRows();
        }
        this.propertyCount = this.propertyCount - 1;
        this._toastService.addToast({ title: 'Success', msg: text + ' deleted successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
      }
      else {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Failed to delete ' + text, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
    });
  }
  deleteOffers() {
    var loggedinUserId = this.user.Id;
    this._loader.display(true);
    var offerId = this.selectedOfferId;
    if (offerId > 0) {
      this._propertyManagerService.deleteOffers(offerId, loggedinUserId).subscribe(response => {
        if (response.toString() == 'true') {
          this._toastService.addToast({
            title: 'Success', msg:
              'Offer deleted successfully', timeout:
              5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
          });
        }
        else {
          this._toastService.addToast({
            title: 'Error', msg:
              'Error deleting Offer', timeout:
              5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
          });
        }
        this.dtElement.dtInstance.then(x => x.draw());
        this._loader.display(false);
      });
    }
  }
  loadMyproperty(tabType) {
    this.onRedirection();
    this.currentTab = tabType;
    this._propertyListingService.activePropertyTab = tabType;
    this.searchCriteria.PropertyFor = tabType;
    this.searchCriteria.IsTileList = true;
    this.resetSelectedRows();
    this.BindColumns();
    this.dtElement.dtInstance.then(x => x.draw());
    //this.propertySearchCriteria(this.searchCriteria);
    //this.dtElement.dtInstance.then((dtInstance) => {
    //  dtInstance.destroy();
    //  $(".paginate_button.first").click()
    //  this.dtTrigger.next(true);
    //});
  }
  ConfirmationHeading = '';
  confirmBody = '';
  compOrArhive = CompOrArhive.Comp;
  showSelectStatus = false;
  statesList: IStatesList[];
  brokers: BrokerSelecttionModel[] = [];
  brokerLicenses: SavePropertyBrokerInputModel[] = [];
  onActionSelect(event, template: TemplateRef<any>, classes, CompOrArchive, AssignBroker, BulkDelete, OfferDelete) {
    if (this.selectedRows.length == 0) {
      this._toastService.addToast({ title: 'Error Occurred', msg: 'Please select at least 1 item.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
    }
    else {
      if (this.selectedAction == Actions.ChangeStatus) {
        this.statusToChange = 0;
        this.showSelectStatus = false;
        this.modalRef = this.modalService.show(template, { class: classes });
      }
      else if (this.selectedAction == Actions.MarkAsComp) {
        this.ConfirmationHeading = "Mark as comp";
        this.confirmBody = 'Are you sure to mark the selected ' + this.getSelectedCount() + ' properties as Comp ?'
        this.compOrArhive = CompOrArhive.Comp;
        this.modalRef = this.modalService.show(CompOrArchive, { class: 'deletemodal' });
      }
      else if (this.selectedAction == Actions.MarkAsArchive) {
        this.ConfirmationHeading = "Mark as archive";
        this.confirmBody = ' Are you sure to Archive the selected ' + this.getSelectedCount() + ' properties ?'
        this.compOrArhive = CompOrArhive.Archive;
        this.modalRef = this.modalService.show(CompOrArchive, { class: 'deletemodal' });
      }
      else if (this.selectedAction == Actions.Delete) {
        this.modalRef = this.modalService.show(BulkDelete, { class: 'deletemodal' });
      }
      else if (this.selectedAction == Actions.AssignBroker) {
        this.assignClicked = false;
        this._commonService.getStateList().subscribe(response => {
          this.statesList = response.map(o => { return { Id: o.Id, Name: o.StateName }; });
        });
        this.brokers = [];
        this.resetBrokerAssign();
        this.modalRef = this.modalService.show(AssignBroker, { class: classes });
      }
      else if (this.selectedAction == Actions.MergeRecords) {
        let selectedProperties = this.selectedRows.filter(x => x.IsPortfolio == false).map(o => o.Id);
        if (selectedProperties.length <= 1) {
          this._toastService.addToast({ title: 'Error Occurred', msg: 'Please select more than 1 property.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        }
        else {
          this.resetSelectedRows();
          this.router.navigateByUrl('/merge/properties?pid=' + JSON.stringify(selectedProperties) + '&p=Live Listing&l=' + this.router.url);
        }
      }
    }
    event.target.value = 0;
  }
  getSelectedCount() {
    //let count = 0;
    //this.propertiesEx.forEach(item => {
    //    if (item.IsSelected) {
    //        count++;
    //    }
    //});
    //return count;
    return this.selectedRows.length;
  }
  selectOrUnSelectAll(trueOrfalse) {
    this.propertiesEx.forEach(item => {
      item.IsSelected = trueOrfalse;
      if (trueOrfalse) {
        // if true then push all selected items into selectedRows collection
        if (this.selectedRows.findIndex(x => x.Id == item.Id) < 0) {
          this.selectedRows.push(item);
        }
      }
      else {
        // if false then current item from the selected row collection
        this.selectedRows.splice(this.selectedRows.findIndex(x => x.Id == item.Id), 1);
      }
    });
    this.preserveSelectedRows();
    if (!trueOrfalse) {
      this.selectAll = false;
    }
  }

  changeStatus() {

    if (this.statusToChange == Actions.NothingSelected) {
      this.showSelectStatus = true;
    }
    else {
      this.showSelectStatus = false;
      this.loaderService.display(true);

      this.propertyIdList = [];
      this.selectedRows.forEach(item => {
        this.propertyIdList.push(
          {
            PropertyId: item.Id,
            Type: 2
          });
      });
      var loggedinUserId = this.user.Id;
      this._propertyListingService.BulkStatusChange(this.statusToChange, this.propertyIdList, loggedinUserId).subscribe(response => {
        if (response) {
          this.selectOrUnSelectAll(false);
          this.dtElement.dtInstance.then(x => x.draw(false));
          this._toastService.addToast({ title: 'Success', msg: 'Status changed successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
          this.modalRef.hide();
          this.resetSelectedRows();
        }
        else {
          this._toastService.addToast({ title: 'Error Occurred', msg: 'Failed to change status', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        }
        this.loaderService.display(false);
      });
    }
  }

  markCompOrArchive() {
    this.loaderService.display(true);
    this.propertyIdList = [];
    this.selectedRows.forEach(item => {
      this.propertyIdList.push(
        {
          PropertyId: item.Id,
          Type: 2
        });
    });
    var loggedinUserId = this.user.Id;
    this._propertyListingService.BulkStatusChange(this.compOrArhive, this.propertyIdList, loggedinUserId).subscribe(response => {
      if (response) {
        this.selectOrUnSelectAll(false);
        this.dtElement.dtInstance.then(x => x.draw(false));
        this._toastService.addToast({ title: 'Success', msg: 'Successfully marked as ' + (this.compOrArhive == CompOrArhive.Comp ? 'Comp' : 'Archive'), timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
        this.resetSelectedRows();
      }
      else {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Failed to mark properties as ' + (this.compOrArhive == CompOrArhive.Comp ? 'Comp' : 'Archive'), timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
      this.loaderService.display(false);
    });
  }
  onStateSelect() {
    if (this.assignBrokerInputModel.stateId != 0) {
      this._propertyManagementService.getBrokers(this.assignBrokerInputModel.stateId).subscribe(response => {
        this.brokers = response;
      });
    }
    else {
      this.brokers = [];
    }
    this.brokerLicenses = [];
    this.assignBrokerInputModel.brokerId = 0;
    this.assignBrokerInputModel.licenseId = 0;
  }
  onBrokerChange() {
    if (this.assignBrokerInputModel.brokerId != 0) {
      this._propertyManagementService.getBrokerLicenses(this.assignBrokerInputModel.brokerId).subscribe(response => {
        this.brokerLicenses = response;
      });
    }
    else {
      this.brokerLicenses = [];
    }
    this.assignBrokerInputModel.licenseId = 0;
  }

  assignClicked = false;
  assignBroker() {
    this.assignClicked = true;
    if (!this.Validation.isInvalidDropDown(this.assignBrokerInputModel.stateId) && !this.Validation.isInvalidDropDown(this.assignBrokerInputModel.brokerId) && !this.Validation.isInvalidDropDown(this.assignBrokerInputModel.licenseId)) {
      this.loaderService.display(true);
      this.assignClicked = false;
      let propertyId = [];
      this.selectedRows.forEach(item => {
        propertyId.push(item.Id);
      });

      this.assignBrokerInputModel.propertyId = propertyId;

      this._propertyManagementService.BulkBrokerAssign(this.assignBrokerInputModel).subscribe(response => {
        if (response) {
          this.selectOrUnSelectAll(false);
          this.dtElement.dtInstance.then(x => x.draw(false));
          this._toastService.addToast({ title: 'Success', msg: 'Successfully assigned brokers.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
          this.resetSelectedRows();
          this.modalRef.hide();
        }
        else {
          this._toastService.addToast({ title: 'Error Occurred', msg: 'Failed to assign brokers', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        }
        this.loaderService.display(false);
      });

    }
  }
  onSelectAll(event) {
    if (event.target.checked) {
      this.selectOrUnSelectAll(true);
    }
    else {
      this.selectOrUnSelectAll(false);
    }
  }
  selectAll = false;
  onCheckboxChange(event, Id) {
    if (event.target.checked) {
      let prop = this.propertiesEx.find(x => x.Id == Id);
      this.selectedRows.push(prop);
    }
    else {

      this.selectedRows.splice(this.selectedRows.findIndex(x => x.Id == Id), 1);
    }
    this.preserveSelectedRows();
    this.autoSelectAll();
  }

  autoSelectAll() {
    if (this.propertiesEx.filter(x => x.IsSelected == true).length == this.propertiesEx.length && this.propertiesEx.length > 0) {
      this.selectAll = true;
    }
    else {
      this.selectAll = false;
    }
  }

  onbulkDelete() {
    this.loaderService.display(true);
    this.propertyIdList = [];
    this.selectedRows.forEach(item => {
      this.propertyIdList.push(
        {
          PropertyId: item.Id,
          Type: 2
        });
    });
    var loggedinUserId = this.user.Id;
    this._propertyListingService.BulkStatusChange(3, this.propertyIdList, loggedinUserId).subscribe(response => {
      if (response) {
        this.selectOrUnSelectAll(false);
        this.dtElement.dtInstance.then(x => x.draw(false));
        this._toastService.addToast({ title: 'Success', msg: 'Properties deleted successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
        this.modalRef.hide();
      }
      else {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Failed to delete properties', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
      this.loaderService.display(false);
    });
  }

  VerifyProperty(propertyId: number, IsPortfolio) {
    this.loaderService.display(true);
    this._brokerageManagerService.VerifyProperty(propertyId).subscribe(resp => {
      this.dtElement.dtInstance.then(x => x.draw(false));
      this.loaderService.display(false);
      this._toastService.addToast({
        title: 'Success',
        msg: IsPortfolio ? 'Portfolio cross verified with source' : 'Property cross verified with source',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'success'
      });
    });
  }

  onHomeBreadCrumbClick() {
    this.router.navigateByUrl('/principal-dashboard');
  }

  //sharedList: ISharedList[];
  selectedProperties: IProperty[];
  openModalForShareListing(template: TemplateRef<any>, classes: any) {
    //this.selectedProperties = this.selectedRows;
    this.selectedProperties = this.propertiesEx.filter(x => x.IsSelected == true)
    if (this.selectedProperties.length == 0) {
      this._toastService.addToast({ title: 'Error Occurred', msg: 'Please select at least 1 item.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
    }
    else {
      this.modalRefShareListing = this.modalService.show(template, { class: classes });
    }
  }
  openModalForShareOM(template: TemplateRef<any>, classes: any) {
    this.sharedOmProperties = this.propertiesEx.filter(x => x.IsSelected == true).map(x => x.Id);
    if (this.sharedOmProperties.length == 0) {
      this._toastService.addToast({ title: 'Error Occurred', msg: 'Please select at least 1 property.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
    }
    else {
      let sharedOMlength = this.sharedOmProperties.length;
      let fileExist = this.propertiesEx.filter(x => x.IsSelected == true && x.IsOMExists == 0);
      let fileLength = fileExist != null ? fileExist.length : 0;
      if (fileLength == sharedOMlength) {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'OM files not available for the selected properties.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
      else {
        this.modalRefOM = this.modalService.show(template, { class: classes });
      }
    }
  }
  removeProperty(propertyId: number) {
    this.selectAll = false;
    let prop = this.propertiesEx.find(x => x.Id == propertyId);
    if (prop) {
      prop.IsSelected = false;
    }
    this.selectedRows.splice(this.selectedRows.findIndex(x => x.Id == propertyId), 1);
    if (propertyId == 0) {
      this.resetSelectedRows();
    }
    this.preserveSelectedRows();
  }

  resetSelectedRows() {
    this.selectedRows = [];
    if (this.propertiesEx) {
      this.propertiesEx.forEach(item => {
        item.IsSelected = false;
      });
    }
    this.selectAll = false;
    this.preserveSelectedRows();
  }

  preserveSelectedRows() {
    localStorage.setItem("livelisting_selectedRows", JSON.stringify(this.selectedRows));
    localStorage.setItem("livelisting_selectedRows_currentTab", JSON.stringify(this.currentTab));
  }
  reassignSelectedRows() {
    if (this.selectedRows.length == 0 && localStorage.getItem("livelisting_selectedRows") !== null) {
      if (localStorage.getItem("livelisting_selectedRows_currentTab") !== null) {
        if (this.currentTab !== parseInt(localStorage.getItem("livelisting_selectedRows_currentTab"))) {
          this.resetSelectedRows();
        }
        else {
          this.selectedRows = JSON.parse(localStorage.getItem("livelisting_selectedRows"));
        }
      }
      else {
        this.selectedRows = JSON.parse(localStorage.getItem("livelisting_selectedRows"));
      }
    }
  }

  onSelectedColumsChange() {
    //this.defaultTypeText.defaultTitle = 'Columns (' + this.selectedColumns.length + ')';
  }

  onRedirection() {
    if (this.currentTab == PropertyType.Sale) {
      localStorage.setItem("live_listings_sale_selectedColumns_LS", JSON.stringify(this.selectedColumns));
    }
    else {
      localStorage.setItem("live_listings_1031_selectedColumns_LS", JSON.stringify(this.selectedColumns));
    }
  }

  modalRefDuplicate: BsModalRef;
  selectedPropertyIdForDuplicates = 0;
  openModalForDuplicates(template: TemplateRef<any>, classes: any, id) {
    this.selectedPropertyIdForDuplicates = id;
    this.modalRefDuplicate = this.modalService.show(template, { class: classes });
  }

  showPortfolioProperties(id, index) {

    this.searchCriteria.PropertyId = id;
    if (this.propertiesEx[index].PortfolioProperties == undefined || this.propertiesEx[index].PortfolioProperties.length == 0) {
      this.loaderService.display(true);
      this._propertyListingService.GetPortfolioPropertiesList(this.searchCriteria).subscribe(item => {
        this.propertiesEx[index].PortfolioProperties = item;
        this.propertiesEx[index].PortfolioProperties.forEach(p => {
          p.Remaining_Term = this.Validation.remainingTermForCardandTables(p.LeaseExpiration, p.LeaseCommencementDate);
          if (p.CharacteristicsId == 1) {
            p.capRateText = 'ZCF';
          }
          else {
            p.capRateText = p.CapRate;
          }
        });
        this.propertiesEx[index].ShowPortfolioProperties = true;
        this.loaderService.display(false);
      })
    }
    else {
      this.propertiesEx[index].ShowPortfolioProperties = !this.propertiesEx[index].ShowPortfolioProperties;
    }
  }

  async showAllPortfolioProperties(ids) {
    this.searchCriteria.PropertyIds = ids;
    this.searchCriteria.LoggedInUserId = this.user.Id;
    await this._propertyListingService.GetPortfolioPropertiesListByIds(this.searchCriteria).subscribe(item => {
      this.searchCriteria.PropertyIds.forEach(k => {

        let date = item;
        let index = this.propertiesEx.findIndex(x => x.Id == k);
        this.propertiesEx[index].PortfolioProperties = item.filter(x => x.PortfolioPropertyId == k);
        this.propertiesEx[index].PortfolioProperties.forEach(item => {
          item.Remaining_Term = this.Validation.remainingTermForCardandTables(item.LeaseExpiration, item.LeaseCommencementDate);
        });
        this.propertiesEx[index].ShowPortfolioProperties = false;
      });
    });
  }

  @ViewChild('searchComp') child: any;
  divClicked() {
    this.child.closeAdvanceFilter();
  }

  openBuyerModal(template: TemplateRef<any>, classes: any, id: number, index: number) {
    this.BuyerQuestionsOfferId = id;
    this.BuyerQuestionsPropertyId = index;
    this.modalBuyerRef = this.modalService.show(template, { class: classes });
  };
  SendBuyerQuestionsRemainder(offerId: number) {
    this.offerService.SendBuyerQuestionsRemainder(offerId, this.user.Id).subscribe(response => {
      if (response.toString() == 'true') {
        this._toastService.addToast({
          title: 'Success', msg:
            'Reminder sent successfully', timeout:
            5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
        });
      }
      else {
        this._toastService.addToast({
          title: 'Error', msg:
            'Error occured', timeout:
            5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
        });
      }
    });
  }

  async LoadPropertyStatus() {
    await this._commonService.getPropertyStatus().subscribe(response => {
      let propertyStatus = response.map(o => {
        return {
          id: o.Id, description: o.Description
        };
      });
      this.propertyStatusList = propertyStatus.filter(x => x.id !== 354);
      this.propertyStatusList.splice(this.propertyStatusList.findIndex(x => x.id == 349), 1);
      this.propertyStatusList.splice(this.propertyStatusList.findIndex(x => x.id == 350), 1);
    });
  }
}
